import { jsx, jsxs } from 'react/jsx-runtime';
import { detectMobile } from '@fabric-app/utils/detection';
import { DropdownMenu } from '@fabric-app/ui/components/DropdownMenu/DropdownMenu';
import { pickImages } from '../utils/pickImages.js';
import { takePicture } from '../utils/takePicture.js';
import { IconNavigational24Camera } from '@fabric-app/icons/svg';
import { useState } from 'react';
import { IconUploadArrow } from '@fabric-app/icons/old';
import { isInMobile } from '@fabric-app/compat';

const TakeOrPickImage = ({ limit, onSetImages, renderTriggerElement }) => {
  const [open, setOpen] = useState(false);
  const handleTakePicture = async () => {
    try {
      const image = await takePicture();
      onSetImages?.([
        image
      ]);
    } catch {
    }
  };
  const handlePickImages = async () => {
    try {
      const images = await pickImages({
        limit
      });
      onSetImages?.(images);
    } catch {
    }
  };
  const onOpenChange = (v) => {
    if (!detectMobile() && v) {
      handlePickImages();
      return;
    }
    setOpen(v);
  };
  return /* @__PURE__ */ jsx(DropdownMenu.Base, {
    openProps: {
      open,
      onOpenChange: (v) => onOpenChange(typeof v === "boolean" ? v : v(open ?? false))
    },
    renderTriggerElement,
    children: /* @__PURE__ */ jsxs(DropdownMenu.Group, {
      children: [
        /* @__PURE__ */ jsx(DropdownMenu.Item, {
          iconElement: /* @__PURE__ */ jsx(IconNavigational24Camera, {}),
          onClick: () => {
            handleTakePicture();
          },
          children: "Take Picture"
        }),
        /* @__PURE__ */ jsxs(DropdownMenu.Item, {
          iconElement: /* @__PURE__ */ jsx(IconUploadArrow, {}),
          onClick: () => {
            handlePickImages();
          },
          children: [
            "From ",
            isInMobile("ios") ? "Photos" : "Gallery"
          ]
        })
      ]
    })
  });
};

export { TakeOrPickImage as default };
//# sourceMappingURL=TakeOrPickImage.js.map
